import React, { useState } from 'react'
import './About.css'
import img1 from './myphoto.jpg'
export default function About() {
    const [newStyle, setnewStyle] = useState({
        color: 'black',
        backgroundColor: 'white',
        borderRadius: '8px'
    });
    const [btnStyle, setbtnStyle] = useState("Change to dark mode")
    const darkMode = () => {
        if (newStyle.backgroundColor === 'white') {
            setnewStyle({
                color: 'white',
                backgroundColor: 'black',
                borderRadius: '8px'
            });
            setbtnStyle("Change to light mode")
        }
        else {
            setnewStyle({
                color: 'black',
                backgroundColor: 'white',
                borderRadius: '8px'
            });
            setbtnStyle("Change to dark mode");
        }
    }
    return (
        <>

            <div classNameName="container" style={newStyle}>
                <h1 className="container my-3">About us</h1>
                <div className="container">
                    <div className="accordion" id="accordionExample" style={newStyle}>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Accordion Item #1
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample" style={newStyle}>
                                <div className="accordion-body" style={newStyle}>
                                    <strong>This Textutils website is used to convert,count and read the data entered inside the text area:</strong> Their are buttons present in the page which is used to convert lowercase to uppercase, generate an email id,copy content and delete content<code>.Textutils.body</code>it can be used in day today life.
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item" style={newStyle}>
                            <h2 className="accordion-header" id="headingTwo">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    Accordion Item #2
                                </button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                <div className="accordion-body" style={newStyle}>
                                    <strong>The switch located at the right most corner</strong> It is used to convert the white theme of the web page to a fully dark theme with a lots of dashing colors<code>.Textutils-body</code>,it enhances the UI look of the web page.
                                </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingThree">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    Accordion Item #3
                                </button>
                            </h2>
                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                <div className="accordion-body" style={newStyle}>
                                    <strong>The three colourful dots in the Navbar</strong>It is used to change the theme color and background color of the whole body<code>.Textutils-body</code>, it is created only to add beauty to the site.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container my-3">
                        <button type="button" className="btn btn-primary mb-3" onClick={darkMode}>{btnStyle}</button>
                    </div>
                </div>
            </div>
            <div className="container">
                <img src={img1} className="newdata"></img>
                <p className="text my-4"><b>Created by Harsh Agarwal</b></p>
            </div>
        </>
    )
}
